/* ------------------------------------------------------------------
   Untitan - panier tiroir

   1. Selecteur de quantite
      Le theme rend les boutons avec "hidden lg:flex" : invisibles sous
      1024px. On retire la classe en JS et on sort le "-" du conteneur
      pour obtenir  [-] [n] [+]. Deplacer un noeud ne detache pas ses
      ecouteurs : le custom element <quantity-input> continue de marcher.

   2. Suppression d un article
      Le theme ne rend AUCUN bouton de suppression, et data-min="1" empeche
      de descendre a 0 (message "cet article est de minimum 1"). On passe
      data-min a 0 et on ajoute une corbeille qui met la quantite a 0.

   3. Banniere de reduction, recap des economies, reassurance.

   sections/cart-drawer.liquid n est pas modifie.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var observer = null;
  var busy = false;
  var timer = null;

  var TRASH =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3.5 5h13M8 5V3.5h4V5M6 5l.6 11h6.8L14 5M8.5 8.5v5M11.5 8.5v5"/></svg>';

  function drawer() {
    return document.getElementById('CartDrawer');
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' €';
    }
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* --- 1 et 2 : quantite utilisable + suppression possible --- */
  function fixLines(root) {
    root.querySelectorAll('.cart-quantity').forEach(function (box) {
      var wrap = box.querySelector('.quantity__buttons');
      var input = box.querySelector('.quantity__input');
      if (!wrap || !input) return;

      wrap.classList.remove('hidden', 'absolute', 'flex-col', 'h-full');
      wrap.removeAttribute('hidden');

      // Descendre a 0 doit retirer l article, pas afficher une erreur.
      input.setAttribute('data-min', '0');
      input.setAttribute('min', '0');

      var minus = wrap.querySelector('[name="minus"]');
      if (minus && minus.parentNode !== box) box.insertBefore(minus, input);

      // Corbeille : le theme n en fournit aucune.
      var host = box.parentNode;
      if (host && !host.querySelector('.utc-remove')) {
        var btn = el('button', 'utc-remove', TRASH);
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Retirer cet article du panier');
        btn.addEventListener('click', function () {
          input.value = 0;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        host.appendChild(btn);
      }
    });
  }

  function build(cart) {
    var root = drawer();
    if (!root) return;

    if (observer) observer.disconnect();

    fixLines(root);

    root.querySelectorAll('.utc-banner, .utc-gift, .utc-sav, .utc-trust').forEach(function (n) {
      n.remove();
    });

    if (cart && cart.item_count) {
      var header = root.querySelector('.drawer__header');
      var footer = root.querySelector('.drawer__footer');

      if (cart.total_discount > 0 && header && header.parentNode) {
        header.parentNode.insertBefore(
          el('div', 'utc-banner', 'Félicitations ! Votre réduction Untitan est activée.'),
          header.nextSibling
        );
      }

      if (footer) {
        if (cart.total_discount > 0) {
          footer.insertBefore(
            el(
              'div',
              'utc-sav',
              '<span>Réductions</span><b>−' + money(cart.total_discount, cart.currency) + '</b>'
            ),
            footer.firstChild
          );
        }
        footer.appendChild(
          el(
            'div',
            'utc-trust',
            '<span>🚚 Livraison gratuite</span>' +
              '<span>🛡️ 30 jours satisfait ou remboursé</span>'
          )
        );
      }
    }

    watch();
  }

  function refresh() {
    if (busy || !drawer()) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(build)
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    var root = drawer();
    if (root) fixLines(root); // correction immediate, sans attendre le reseau
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  function watch() {
    var root = drawer();
    if (!root) return;
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
  }

  function start() {
    var root = drawer();
    if (!root) return;
    fixLines(root);
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
